module.exports = __webpack_public_path__ + "static/media/81gU8AZ4WaL._AC_UX569_.7561f108.jpg";